DialogEditConfigTipoDistrCtrl.$inject = ['$log', '$scope', '$http', '$timeout', '$rootScope'];
export default function DialogEditConfigTipoDistrCtrl($log, $scope, $http, $timeout, $rootScope) {

    var TAG = 'DialogEditConfigTipoDistrCtrl: ';
    var URL_TIPOS_BASE = Sigo.var.path + '/mantenimiento/tipos-uniges';

    var vm = this;

    vm.model = $scope.model;
    vm.dialogHandler = $scope.dialog;
    vm.cargando = {
        datos: false,
        submit: false
    };
    vm.formDeshabilitado = true;
    vm.cargando.datos = true;

    var metodo = vm.model.metodo;

    var url, urlAdd, respuestaPromesa;
    if (metodo == 'add') {
        vm.model.unidad_gestion_tipo_id = vm.model.unidadGestionTipoId;
        url = '/add-distr-datos/' + vm.model.unidadGestionTipoId;
        urlAdd = '/add-distr/' + vm.model.unidadGestionTipoId;
    } else {
        url = '/edit-distr-datos/' + vm.model.unidadGestionTipoDistritoId;
        urlAdd = '/edit-distr/' + vm.model.unidadGestionTipoDistritoId;
        respuestaPromesa = function (data) {
            vm.model = data.data.uniGesTipoDistrito;
        };
    }

    var promesa = $http.get(URL_TIPOS_BASE + url);
    promesa.then(function (data) {
        vm.datos = data.data;
        if (issetAndNotEmpty(respuestaPromesa)) respuestaPromesa(data);
        vm.cargando.datos = false;
        vm.formDeshabilitado = false;
        $rootScope.$broadcast('datosFormAsignacion', {'data': data.data, 'model': vm.model});
    });

    vm.guardarConfigTipoDistr = function (tipoDistr) {
        vm.cargando.submit = true;
        vm.formDeshabilitado = true;

        promesa = $http.post(URL_TIPOS_BASE + urlAdd, tipoDistr);
        promesa.then(function (data) {
            vm.dialogHandler.close();
        });
    };

    vm.cancelar = function () {
        vm.dialogHandler.cancel();
    };

}